import Router from '@/router';

export const minimumPasswordSize = (v, min = null) => (v.length < min ? true : false);

export const quantityUppercasePassword = (v, min = null) => {
  const regex = new RegExp(`(?=(?:.*?[A-Z]){${min}})`);

  if (!regex.test(v)) return true;

  return false;
};

export const quantityNumbersPassword = (v, min = null) => {
  const regex = new RegExp(`(?=(?:.*?[0-9]){${min}})`);

  if (!regex.test(v)) return true;

  return false;
};

export const notContainLoginInPassword = v => {
  let { name } = JSON.parse(sessionStorage.getItem('i4pro-portal')).authentication.user;

  if (!!name === false) {
    const { token } = Router.history.current.params;

    const base64 = token
      .split('.')[1]
      .replace('-', '+')
      .replace('_', '/');

    name = JSON.parse(window.atob(base64)).userName;
  }

  if (v.toLowerCase().includes(name.toLowerCase())) return true;

  return false;
};

export const validationCaseSensitive = (v, min = null) => (v.length < min ? true : false);

export const requireCharacterSpecial = v => {
  const regex = new RegExp(/\W|_/);

  if (!regex.test(v)) return true;

  return false;
};

export const forbidThreeNumbersSequential = v => {
  const regex = new RegExp(`(012|123|234|345|456|567|678|789|890|210|321|432|543|654|765|876|987|000|111|222|333|444|555|666|777|888|999)`);

  if (regex.test(v)) return true;

  return false;
};

export const quantityCharactersAlpha = (v, min = null) => {
  const regex = new RegExp(`[A-Za-z]{${min}}`);

  if (!regex.test(v)) return true;

  return false;
};

export const quantityPasswordsDoNotRepeat = (v, min = null) => (v.length < min ? true : false);
